import * as R from "ramda";
import React from "react";

import { getValue, getSettings } from "../../utils";
import { ROW_ACTIONS } from "../../constants";
import { actions } from "../../model";
import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";

const decorate = connect(
  null,
  bindInstance({
    execute: actions.executeAction
  })
);

const ContentStatus = props => {
  const value = getValue(props); //["download", "generating","Failed"]
  const options = getSettings(props, "options", []);

  if (value) {
    const selectedOption = R.find(R.propEq("id", value.id), options);
    const toggledRows = R.path(["data", "data", "session_ids"], props);
    const url = R.path(["data", "data", "download_url"], props);
    const groupByOrder = R.path(["data", "data", "group_by_order"], props);
    return (
      <div
        style={{
          userSelect: "none",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          cursor: "pointer"
        }}
      >
        <div
          style={{
            marginRight: 4,
            borderRadius: 4,
            fontSize: 12,
            padding: "4px 8px",
            lineHeight: "normal",
            whiteSpace: "nowrap",
            flexBasis: "auto",
            flexShrink: 0,
            backgroundColor:
              // completed #51CF66 , generating #FFCF3D , failed #e03131
              R.prop("backgroundColor", selectedOption) || "#FFCF3D",
            color: R.prop("textColor", selectedOption) || "#494949"
          }}
          onClick={() => {
            if (R.propEq("value", "Download", selectedOption)) {
              window.open(url, "_blank");
            } else if (R.propEq("value", "Failed", selectedOption)) {
              props.execute({
                actionId: ROW_ACTIONS.OPEN_DOWNLOAD_CONTENT,
                toggledRows,
                groupByOrder
              });
            }
          }}
        >
          {value.value}
        </div>
      </div>
    );
  } else return null;
};

export default decorate(ContentStatus);
